import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';
import { typography } from '@shared/tokens/typography.stylex.ts';

export const styles = stylex.create({
  filtersContainer: {
    fontFamily: fonts.din2014Regular,
    height: '100%',
    padding: '24px',
    backgroundColor: colors.brandGhostBackground,
    borderRadius: anatomy.borderRadiusS,
    gap: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
  filtersTitle: {
    fontSize: typography['fontSizeBody-2'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: '24px',
    color: colors.primaryText,
  },
  filters: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    ':not(#__unused__) [data-testid="label-txt"]': {
      height: '16px',
    },
  },
  filter: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  filterFieldset: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  filterTitle: {
    fontSize: typography['fontSizeBody-4'],
    fontWeight: typography.fontWeighDemi,
    lineHeight: '20px',
    color: colors.primaryText,
  },
  filterDescription: {
    fontSize: typography['fontSizeBody-5'],
    lineHeight: '16px',
    color: colors.tertiaryText,
  },
  filterFormatButtons: {
    display: 'flex',
    gap: '8px',
    ':not(#__unused__) button': {
      padding: '8px 14px',
    },
  },
  searchInputWrapper: {
    position: 'relative',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    ':not(#__unused__) > div': {
      width: '100%',
    },
    ':not(#__unused__) input': {
      paddingRight: '40px',
    },
  },
  searchIcon: {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  crossIcon: {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
});
